import React from "react"
import { Link, withRouter } from "react-router"
import classNames from "classnames"
import { apiAuth } from "../../api"
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from "react-intl"
import sharedMessages from "../../messages/index"
import profileMessages from "../../messages/profile"
import settingsMessages from "../../messages/settings"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyleTag } from "../../styles/dynamicStyles"

class ChangePassword extends React.Component {
  state = {
    password: "",
    passwordConfirm: "",
    tokenValid: null,
    done: false,
    loading: false,
    user: {},
    errors: {}
  }

  componentDidMount() {
    this.confirmToken()
  }

  changeField = evt => {
    if (evt) evt.preventDefault()

    const { value, name } = evt.target
    this.setState({
      [name]: value
    })
  }

  blurField = evt => {
    this.setState({
      errors: this.validateFields()
    })
  }

  validateFields = (errors = {}) => {
    const { intl } = this.props
    const { password, passwordConfirm } = this.state
    if (password.length < 6) {
      errors.password = intl.formatMessage(profileMessages.longerPassword)
    }

    if (password.length >= 6 && password !== passwordConfirm) {
      errors.passwordConfirm = intl.formatMessage(
        messages.passwordConfirmationMismatch
      )
    }
    return errors
  }

  getToken = () => {
    const {
      location: {
        query: { reset_password_token: token }
      }
    } = this.props

    return token
  }

  confirmToken = () => {
    const { intl } = this.props
    const token = this.getToken()

    this.setState({ loading: true })

    if (!token) {
      this.setState({
        errors: { error: intl.formatMessage(profileMessages.invalidToken) }
      })
      return
    }

    apiAuth("GET", `/user/password/${token}`)
      .then(user =>
        this.setState({
          tokenValid: true,
          loading: false,
          user
        })
      )
      .catch(err => {
        this.setState({
          errors: err.json || {
            error: intl.formatMessage(sharedMessages.somethingWentWrong)
          },
          loading: false
        })
      })
  }

  onSubmit = evt => {
    const { intl } = this.props
    const { password } = this.state

    if (evt) evt.preventDefault()

    const errors = this.validateFields()

    if (Object.values(errors).length > 0) {
      this.setState({ errors })
      return false
    }

    this.setState({ loading: true })

    const token = this.getToken()

    apiAuth("POST", `/user/password/${token}`, { password })
      .then(() => this.setState({ done: true }))
      .catch(err => {
        this.setState({
          errors: err.json || {
            error: intl.formatMessage(sharedMessages.somethingWentWrong)
          },
          loading: false
        })
      })
  }

  render() {
    const { intl } = this.props
    const { errors, password, passwordConfirm, tokenValid, done } = this.state
    const accountSettings = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const styleBodyType = accountSettings.settings.style.content || ""

    return (
      <main id="main" role="main" tabIndex={0} data-component="Login">
        {getStyleTag("form-message")}
        {styleBodyType === "default" ? (
          <div className="row" id="item-info">
            <div className="small-12 columns">
              <h1 className="beta mbt">
                <FormattedMessage {...sharedMessages.formResetPassword} />
              </h1>
            </div>
          </div>
        ) : null}

        {styleBodyType !== "default" ? (
          <div className="title">Reset Password</div>
        ) : null}

        <div className="row" id="item-info">
          <div className="small-12 columns auth__main-column">
            {!tokenValid && (
              <p>
                <FormattedMessage
                  id="profile.something-went-wrong-reset-password"
                  defaultMessage="Sorry, something went wrong. Please try {resetLink}"
                  values={{
                    resetLink: (
                      <Link to="/reset-password">
                        <strong>
                          <FormattedMessage {...profileMessages.resetLink} />
                        </strong>
                      </Link>
                    )
                  }}
                />
              </p>
            )}
            {!!errors.error && (
              <div className="form-message state-error">{errors.error}</div>
            )}
            {tokenValid &&
              !done && (
                <form
                  autoComplete="off"
                  onSubmit={this.onSubmit}
                  className={classNames("form--can-load", {
                    "state-form-loading": this.state.loading
                  })}
                >
                  <div>
                    <input
                      type="password"
                      autoComplete={false}
                      placeholder={intl.formatMessage(profileMessages.password)}
                      name="password"
                      value={password}
                      onChange={this.changeField}
                      required
                    />
                    {errors.password && (
                      <span className="form-message state-error">
                        {errors.password}
                      </span>
                    )}
                  </div>
                  <div>
                    <input
                      type="password"
                      autoComplete={false}
                      placeholder={intl.formatMessage(
                        profileMessages.confirmPassword
                      )}
                      name="passwordConfirm"
                      value={passwordConfirm}
                      onChange={this.changeField}
                      required
                    />
                    {errors.passwordConfirm && (
                      <span className="form-message state-error">
                        {errors.passwordConfirm}
                      </span>
                    )}
                  </div>

                  {!done && (
                    <div className="vertical-align-middle">
                      <button
                        className={classNames("button man button--can-load", {
                          "state-loading": this.state.loading
                        })}
                        type="submit"
                      >
                        <FormattedMessage {...profileMessages.resetPassword} />
                      </button>
                    </div>
                  )}
                </form>
              )}

            {done && (
              <div>
                <p>
                  <FormattedHTMLMessage
                    {...profileMessages.updatedPasswordSuccess}
                  />
                </p>
                <Link to="/login">
                  <button className="button mtt" type="button">
                    <FormattedMessage {...sharedMessages.buttonLogIn} />
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </main>
    )
  }
}

export default withRouter(injectIntl(ChangePassword))



// WEBPACK FOOTER //
// ./webapp/components/pages/ChangePassword.js